import { AixAction } from './aix-action';
import { ErrorWrapper } from './models/common';

export class AixErrorAction implements AixAction {
    readonly type = 'AixError Failure';

    constructor(public payload: { error: ErrorWrapper }) {}
}
